export const FACEBOOK_PAGE_SCOPES = [
  'pages_manage_metadata',
  'business_management',
  'pages_messaging',
  'pages_show_list',
  'pages_read_engagement',
  'pages_read_user_content',
  'pages_manage_engagement',
];

// Escopos usados somente quando a Página também está ligada a uma conta
// profissional do Instagram. Não inclua os escopos instagram_business_* aqui:
// eles pertencem ao Instagram Login e fazem o diálogo do Facebook falhar.
export const INSTAGRAM_PAGE_SCOPES = [
  'instagram_basic',
  'instagram_manage_comments',
  'instagram_manage_engagement',
];

export const buildFacebookLoginScopes = ({
  includeInstagramScopes = false,
} = {}) => {
  const scopes = [...FACEBOOK_PAGE_SCOPES];
  if (includeInstagramScopes) scopes.push(...INSTAGRAM_PAGE_SCOPES);

  return scopes.join(',');
};
